import leafio from '@montugroup/themes/brands/leafio';
import { BrandThemeProvider } from '@montugroup/themes/styles';
import type { FC, PropsWithChildren } from 'react';

export const LeafioThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  return <BrandThemeProvider theme={leafio}>{children}</BrandThemeProvider>;
};
